import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { getUserData } from "../utils/auth";

const CasinoLayout = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(() => {
    if (typeof window === "undefined") return null;
    return getUserData();
  });
  return (
    <div className="casino_division">
      <h2 className="userscreen-title">
        <button className="btn-xs casino-back" onClick={() => navigate("/")}>
          <i className="bi bi-house"></i>
        </button>
        <span>{userData?.user_name || userData?.username || "User"}</span>
      </h2>
      <Outlet />
    </div>
  );
};

export default CasinoLayout;
